import { Button } from "components/Buttons";
import { Empty } from "components/Empty/Empty";
import { PatientRegion } from "types/PatientRegion";
import { ButtonColorScheme, ButtonType } from "types/ui";
import { PatientTableHeader } from "../components/Patient/PatientTableHeader";
import { Link } from "react-router-dom";
import { PatientTableRow } from "../components/Patient/PatientTableRow";
import { PAGES } from "constants/pages";
import { getRouteLink } from "utils/general";

type Props = {
    patientRegionsState: PatientRegion[];
    onClick?: any;
    sortConfig: any;
    loading: boolean
    onLoadMore:any
    hasMoreItems:boolean
};

export const ContainerForClinicians = ({
    patientRegionsState,
    onClick,
    sortConfig,
    loading,
    onLoadMore,
    hasMoreItems
}: Props) => {

    return (
        <>
          <PatientTableHeader onClick={onClick} sortConfig={sortConfig} />
          <div className="w-full min-h-[200px] flex flex-col overflow-x-scroll overflow-y-hidden space-y-[5px] relative">
            {patientRegionsState?.map((patientRegion) => {

              return (
                <Link
                  key={patientRegion._id}
                  to={`${getRouteLink(PAGES.patientDetails)}${patientRegion.patient._id
                    }`}
                >
                  <PatientTableRow
                    key={patientRegion._id}
                    patientImage={patientRegion.patient.profileInfo.firstName}
                    firstName={patientRegion.patient.profileInfo.firstName}
                    lastName={patientRegion.patient.profileInfo.lastName}
                    dateOfBirth={patientRegion.patient.profileInfo.dateOfBirth}
                    scores={patientRegion.outcomeScore}
                    region={patientRegion.region}
                    week={patientRegion ? patientRegion?.week : 0}
                    lastExam={patientRegion.lastExam}
                  />
                </Link>
              );
            })}

            {!loading && !patientRegionsState.length && (
              <div className="m-auto">
                <Empty />
              </div>
            )}

            {loading && (
              <div className="flex items-center justify-center w-full h-full absolute overflow-hidden bg-bgLight/50 ">
                <div className="spinner" />
              </div>
            )}
          </div>

          <Button
            classNames="self-end mt-4"
            title="Load More Patients"
            onClick={onLoadMore}
            type={ButtonType.normal}
            disabled={loading || !hasMoreItems}
            colorScheme={
              hasMoreItems ? ButtonColorScheme.gradient : ButtonColorScheme.disabled
            }
            shadowed={hasMoreItems}
          />
        </>
    )
};